import ReactDOMServer from 'react-dom/server'

export const svgString = (MySvgComponent: React.ReactElement): string =>
  ReactDOMServer.renderToStaticMarkup(MySvgComponent)

// Function to construct the SVG string from the Font Awesome icon
export const getSvgFromIcon = (
  icon: any,
  height: number | null = 16,
  width: number | null = 16,
  color: string | null = 'currentColor',
): string => {
  if (!icon || !icon.icon || icon.icon.length < 4) {
    console.error('Invalid icon structure')
    return ''
  }

  const paths = icon.icon[4]
  const viewBox = `0 0 ${icon.icon[0]} ${icon.icon[1]}`

  return `
    <svg 
      aria-hidden="true" 
      focusable="false" 
      data-prefix="far" 
      data-icon="paperclip" 
      class="svg-inline--fa fa-paperclip sc-jRQBWg ldoKVI" 
      role="img" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="${viewBox}" 
      fill=${color}
      style="height: ${height}px; width: ${width}px; fill: ${color}"
    >
      <path d="${paths}" />
    </svg>
  `
}
